import axios from 'axios'

export default {
    getNotifications(userId, query, fields) {
        const _fields = (fields || ['id', 'userId', 'notificationType', 'isSeen', 'data']).join(',')

        const params = {
            _fields,
            ...query,
        }
        return axios.get(`notifications/user/${userId}`, { params })
    },

    reportCreMessageAnswered(notificationId) {
        return axios.post(`notifications/${notificationId}/cre-message-answered`)
    },
}
